/**
 * Configuration file for Auth0
 *
 * This file is where you define overrides for the default auth0 parameters.
 */

export default {
  clientID: 'zf5SMkng6DBUhaZSYwKNZs7spp4etmzZ', // LoginPreview SPA (staging tenant)
  domain: 'auth-staging.communityshare.org',
  redirectUri:  'http://localhost:5527/auth/callback',
  responseType: 'token id_token',
  scope: 'openid profile email'
};
